import React from "react";

const Column = props => {
  return <></>;
};
export default Column;
